export function fbLogin() {
  return new Promise((resolve, reject) => {
    if(!FB) return reject(new Error('Facebook is not loaded'));
    FB.login((response) => {
      if (response.authResponse) {
        resolve(response);
      } else {
        const error = new Error('Could not log in');
        error.response = response;
        reject(error);
      }
    }, { scope: 'email', auth_type: 'https' });
  });
}

export function fbShare(shareUrl) {
  return new Promise((resolve,reject) => {
    if(!FB) return reject(new Error('Facebook is not loaded'));
    FB.ui({
      method: 'share',
      href: shareUrl
    }, (response) => {
      if (response) {
        resolve(response);
      } else {
        const error = new Error('Could not share');
        reject(error);
      }
    });
  })
}


// WEBPACK FOOTER //
// ./app/javascript/gateway/facebook.js